const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/transport",
    exact: true,
    component: "Transport",
  },
  {
    path: "/spolki",
    exact: true,
    component: "Spolki",
  },
  {
    path: "/o-nas",
    exact: true,
    component: "About",
  },
  {
    path: "/kontakt",
    exact: true,
    component: "Contact",
  },
];

export default routes;
